// extracted by mini-css-extract-plugin
export default {"sidebar":"confirmCancel_sidebar__aaeqz","text":"confirmCancel_text__XkqiI"};